// import jQuery from 'jquery';

$('.page-scroll-to').click(function() {
  let linkTo = $(this).attr('data-linkTo')
  let scrollCoordinate = document.querySelector(`#${linkTo}`).getBoundingClientRect().top + window.pageYOffset;

  let diff = 0;

  if (window.innerWidth <= 1025) {
    diff = 65
  }

  window.scrollTo({
    top: scrollCoordinate - diff,
    behavior: 'smooth'
  });
});
